module.exports = __webpack_public_path__ + "img/0Q3A6453_L_BlackMatted.d4083347.jpg";